import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { createSafeContext } from "@coveord/plasma-mantine";
var ref = _sliced_to_array(createSafeContext("PrerequisitesList component was not found in tree"), 2);
export var PrerequisitesListProvider = ref[0], usePrerequisitesListContext = ref[1];

//# sourceMappingURL=PrerequisitesList.context.js.map